import * as React from 'react';

export const Header = ({ title }: { title: string }) => {

    return <h3 className="font-bold text-4xl text-gray-900">{title}</h3>
};
